import React, { useEffect, useState } from "react";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";

import summaryProgress from "../../../../images/summary_progress.svg";
import star from "../../../../images/star.svg";
import { THEME_COLOR } from "../../../../styles/colors";

/**
 * AttendeeSummarizingIndicator Component
 *
 * Displays an indicator that a meeting summary is in progress. It includes:
 * - A background image indicating the summarization process.
 * - A title "Summarizing...".
 * - A disclaimer message that disappears after 2 minutes.
 *
 * The disclaimer text:
 * "If you don’t agree to meeting summary, remain on mute, leave the meeting,
 * or ask the organizer to stop summarizing meetings at any time."
 *
 */
const AttendeeSummarizingIndicator = ({ rtmsRequesterName }) => {
  const [showDisclaimer, setShowDisclaimer] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowDisclaimer(false);
    }, 2 * 60 * 1000); // 2 minutes

    return () => clearTimeout(timer);
  }, []);

  return (
    <Column alignment="center" width="100%" spacing="none" spacingInset="none">
      <Column height="64px" />
      <Row spacing="none" spacingInset="none">
        <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.WHITE }}>
          <Box type="outline" spacingInset="none" minWidth="15px"></Box>
        </Theme>
        <img src={summaryProgress} alt="" />
      </Row>
      <Column height="36px" spacing="none" />
      <Column spacing="none" spacingInset="none">
        <Row spacing="none" spacingInset="none">
          <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.WHITE }}>
            <Box type="outline" spacingInset="none" minWidth="68px"></Box>
          </Theme>
          <Text type="h50" alignment="start">
            Summarizing...
          </Text>
        </Row>
      </Column>
      <Column height="16px" spacing="none" />
      {showDisclaimer && (
        <Column spacing="none" spacingInset="none">
          <Row spacing="none" spacingInset="none">
            <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.WHITE }}>
              <Box type="outline" spacingInset="none" minWidth="68px"></Box>
            </Theme>
            <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.WHITE }}>
              <Box type="outline" spacingInset="none" width="253px">
                <Theme tokens={{ textListSpacingVertical: "30px" }}>
                  <Text type="b200" alignment="start" color="secondary">
                    If you don't agree to meeting summary, remain on mute, leave the meeting, or ask the organizer to stop summarizing meetings at any time.
                  </Text>
                </Theme>
              </Box>
            </Theme>
          </Row>
        </Column>
      )}
      {rtmsRequesterName && (
        <>
          <Column height="48px" spacing="none" />
          <Row spacing="none" spacingInset="none">
            <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.WHITE }}>
              <Box type="outline" spacingInset="none" minWidth="68px"></Box>
            </Theme>
            <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.LIGHT_TEAL }}>
              <Box type="outline" spacingInset="400" width="252px">
                <Row spacing="none">
                  <img src={star} alt="star" />
                  <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.WHITE }}>
                    <Box type="outline" spacingInset="none" minWidth="8px"></Box>
                  </Theme>
                  <Column spacing="none">
                    <Text type="h50" alignment="start">
                      {rtmsRequesterName}
                    </Text>
                    <Text type="b200" alignment="start">
                      turned on meeting summary
                    </Text>
                  </Column>
                </Row>
              </Box>
            </Theme>
          </Row>
        </>
      )}
    </Column>
  );
};

export default AttendeeSummarizingIndicator;
